import actionHtml from './action.html';

class ConfiguratorActionComponent {
    constructor($scope) {
        'ngInject';

        this.isOpen = false;
        this.$scope = $scope;
    }

    open() {
        this.isOpen = true;
    }

    close() {
        console.log('ConfiguratorActionComponent::close');
        this.isOpen = false;
    }

    select(item) {
        this.close();
        
        if (this.onSelect && typeof this.onSelect === 'function') {
            const isSuccess = this.onSelect({value: item});
        }
    }
}

let configuratorActionComponent = {
    bindings: {
        'items': '<',
        'text': '@',
        'onSelect': '&',
        'disabled': '<'
    },
    template: actionHtml,
    controller: ConfiguratorActionComponent
};

export default configuratorActionComponent;